export default "__VITE_ASSET__cbee27b3__"